<template> 
  <div>
    <div class="callDiv" v-if="openWbShow">
      <!-- 云呼 -->
      <div @click="openWB(openStatus)" class="mini-workbench">云呼</div> 
    </div>
    <!-- 云呼挂载元素id -->
    <div id="workbench" style="width:300px" :class="{'workbenchBorder':workbenchBorder}" v-if="workbenchStatus"></div> 
  </div>
</template>

<script>

export default {
  name: 'cellCenter',
  data() {
    return {
      openWbShow: false, // 云呼按钮的显示
      openStatus: false, // 控制面板的显示
      workbenchBorder: false, // 面板的边框
      visibleWorkbench: false, // 来电的时候工作台弹窗的显示
      workbenchStatus: true,
      userAliyun: {},
      userInfo: {}
    }
  },
  mounted() {
    this.userAliyun = JSON.parse(this.$store.getters['menu/getUserAliyun'])
    this.userInfo = JSON.parse(this.$store.getters['menu/getUSERINFO'])
    if (this.userAliyun != null) {
      console.log('initWorkBench...')
      this.openWbShow = true
      this.initWorkBench()
    } else {
      this.workbenchStatus = false
    }
  },
  created() {},
  methods: {
    // 云呼相关初始化
    initWorkBench() {
      window.workbench = new window.WorkbenchSdk({
        dom: 'workbench', // 挂载的元素
        width: '300px', // 面板的宽
        height: '500px', // 面板的高
        instanceId: '8bc78fb0-a664-42fe-9291-dde59b41ace5',
        useOpenApiSdk: true,
        ajaxOrigin: 'http://127.0.0.1:8001',
        ajaxPath: '/api/aliyun/ccc/api',
        ajaxMethod: 'post',
        ajaxHeaders: { user_id: this.userInfo.vUserId },
        afterCallRule: 10, // 挂机后的话后处理时间
        header: true,
        defaultVisible: false,
        exportErrorOfApi: true,
        moreActionList: ['mobilePhoneAnswer', 'break', 'offline'],
        onInit: function() {
          window.workbench.register() // 想实现自动上线在此注册
          window.workbench.changeVisible(true) // 可以实现初始化后显示面板
        },
        onErrorNotify: function(error) {
          console.warn(error)
        },
        onCallComing: function(connid, caller, calee, contactId, skillgroupId) {
          // connid: 通话id;caller: 主叫号码;calee:被叫号码;contactId:录音id，通话记录查询需要的字段;skillgroupId:技能组id
          // eslint-disable-next-line no-undef
          eventBus.phone = caller // 将获取的号码，先赋值
          // eslint-disable-next-line no-undef
          eventBus.$emit('callComming', caller) // 传递给非父子组件
        },
        onCallDialing: function(connid, caller, calee, contactId) {
          // console.log('这里是',connid,caller,calee,contactId);
        },
        onStatusChange: function(code, lastCode, context) {
          // console.log(code, lastCode, context);
        },
        onCallEstablish: function(connid, caller, calee, contactId) {
          // console.log('这里是通话建立时触发的回调函数', connid, caller, calee, contactId)
        },
        onCallRelease: function(connid, caller, calee, contactId) {
          // console.log('这里是通话结束时触发的回调函数', connid, caller, calee, contactId)
        },
        onHangUp(type) {
          // console.log("挂机");
          // eslint-disable-next-line no-undef
          eventBus.phone = ''
        },
        // eslint-disable-next-line no-dupe-keys
        onStatusChange(code, lastCode, context) {
          // console.log(code, lastCode, context);
        }
      })
    },
    // 云呼相关配置
    openWB(openStatus) {
      // 点击出现云呼面板，再次点击面板消失
      if (openStatus === true) {
        window.workbench.changeVisible(false)
        this.openStatus = false
        this.workbenchBorder = false
      } else {
        window.workbench.changeVisible(true)
        this.openStatus = true
        this.workbenchBorder = true
      }
    }
  }
}
</script>
<style scoped>
  @import "./css/cellCenter.scss";
</style>